<div id="csr_modal" class="know-more-sections">
    <div class="km-close-btn" (click)="Close()" >
        <span class="clicktoclose"><i class="icon-k-close"></i></span>
    </div>
    <div class="km-gia-rang">
        <div class="container">
            <div class="row">
                <div class="gr-content-row bt-0" style="padding-top: 0;">
                    <div class="grc-txt">
                        <h5><b>Planting a better tomorrow</b></h5>
                        <p>Planting a tree is considered the first step to living in a better way and reducing carbon impact on the planet. We have not only adopted that step as our mantra but within a few years,
                            <b>we have successfully planted more than 1000 trees – our way of making a positive impact.</b>
                        </p>

                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>Focusing on water conservation</b></h5>
                        <p>Empowering rural India is the key to development. And what would be better than helping nearby local communities and villages to conserve water!
                            <b>Field bunding, trenching, farm pond construction and deepening are some of the ways that have been implemented to conserve water in rural areas.
                            </b> </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>Partnering with people’s lifelong journey</b></h5>
                        <p>We always look at causes and initiatives that can build a better society where people are provided the basics of life, where people can grow and create a social impact.
                            <b>Partnering people in celebrating a new phase of their life – we believe it’s a true novelty.</b>
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>Supporting the noble cause - Hospital Charity</b></h5>
                        <p>We understand our commitments to our community & consider ourselves extremely blessed to be able to add to the betterment of people. We have initiated activities in the field of medical, a cause that’s so vital in today’s times. Thousands of people suffering from various diseases receive aid and support through our hospital charity.
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>Honoring the Bravehearts of our Nation </b></h5>
                        <p>The Bravehearts who laid their lives protecting the Nation and its people. The Bravehearts who fought relentlessly so that we can sleep at our home peacefully. Through Amar Jawaan Foundation, we pay our homage by supporting and protecting the families they have left behind.
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt">
                        <h5><b>Lending a helping hand - Food kits during Covid 19</b></h5>
                        <p>We are experiencing an unprecedented situation due to the Novel Coronavirus (COVID -19) outbreak in our country. Amidst the life-threatening virus and complete shutdown, the less privileged families were struggling the most. And like always we stood by those who needed us the most. We provided essential kits to thousands of families to help us survive during these trying times.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>